<script setup lang="ts">
  import { useFsfStore } from '@/components/fsf/stores/fsf.store'
  import { useFlightStore } from '@/components/fsf/stores/flight.store'
  import { INBOUND, OUTBOUND } from '@/utils/constants/fsf'
  import type { TFlightType } from '@/components/fsf/types'

  const fsfStore = useFsfStore()
  const flightStore = useFlightStore()

  const setCurrentFlightType = (flightType: TFlightType) => {
    if (flightType === INBOUND && !fsfStore.selectedStartDate) {
      return
    }

    fsfStore.currentFlightType = flightType
  }

  const modelValue = defineModel<string>(OUTBOUND)
</script>

<template>
  <RadioGroupRoot
    v-model="modelValue"
    class="grid w-full grid-cols-2"
  >
    <div>
      <FsfTabItem
        :title="$t('fsf.departure')"
        :is-active="fsfStore.isOutboundFlightType"
        :description="fsfStore.selectedStartDate"
        :price="flightStore.selectedOutboundFlight?.updatedPrice ?? flightStore.selectedOutboundFlight?.price"
        :show-popover="!!flightStore.selectedOutboundFlight?.updatedPrice"
        :value="OUTBOUND"
        :hide-prices="fsfStore.hideFsfPrices || !fsfStore.showPrices"
        @click="setCurrentFlightType(OUTBOUND)"
        @keydown.enter="setCurrentFlightType(OUTBOUND)"
      />
    </div>
    <div :class="{ 'border-b border-b-border': !fsfStore.isRoundTrip }">
      <FsfTabItem
        v-if="fsfStore.isRoundTrip"
        :title="$t('fsf.return')"
        :is-active="!fsfStore.isOutboundFlightType"
        :description="fsfStore.selectedEndDate"
        :price="flightStore.selectedInboundFlight?.price"
        :disabled="!fsfStore.selectedStartDate"
        :value="INBOUND"
        :hide-prices="fsfStore.hideFsfPrices || !fsfStore.showPrices"
        @click="setCurrentFlightType(INBOUND)"
        @keydown.enter="setCurrentFlightType(OUTBOUND)"
      />
    </div>
  </RadioGroupRoot>
</template>
